import { FC, useContext, useEffect, useState } from "react"
import { Button, Container, Header, List, Loader } from "semantic-ui-react"
import { NavBar } from "./NavBar"
import { useChild } from "../hooks"
import { User, UserName } from "../auth/auth"
import { useAccounts } from "../accounts"
import { Link } from "react-router-dom"
import { useQuery } from "@tanstack/react-query"
import { API } from "aws-amplify"
import { GraphQLQuery } from "@aws-amplify/api"
import { AccountInfo, DeleteAccountInfoMutation, GetAccountQuotaQuery } from "../API"
import { getAccountQuota } from "../graphql/queries"
import { deleteAccountInfo } from "../graphql/mutations"

export function useQuota(accountId: string) {
  return useQuery({

    queryKey: [accountId],
    queryFn: async () => (await API.graphql<GraphQLQuery<GetAccountQuotaQuery>>({
      query: getAccountQuota,
      variables: {
        accountId: accountId
      }
    })).data
  })
}

export const RenderAccountQuota: FC<{accountId: string}> = ({accountId}) => {
  const [quota, setQuota] = useState(-1)

  useEffect(() => {
    async function fetchQuota() {
      const getAccountQuotaResponse = await API.graphql<GraphQLQuery<GetAccountQuotaQuery>>({
        query: getAccountQuota,
        variables: {
          accountId: accountId
        }
      });
      setQuota(getAccountQuotaResponse.data?.getAccountQuota?.scanQuota || -1)
    }
    fetchQuota()
  }, [])

  const isLoading = quota === -1

  return (
      <List horizontal>
        <List.Item><List.Header>Scan Quota Balance:</List.Header></List.Item>
        <List.Item>{isLoading ? <Loader active inline size="mini"/> : quota}</List.Item>
      </List>
  )

}

export const Profile: FC = () => {
  const [email] = useChild(useContext(User), 'email');
  const { isLoading, data, refetch } = useAccounts();
  const accounts = data?.getUserInfo?.accounts?.items;
  // empty for no deleting, or successfully deleted
  // accountId when deleting in progress
  // any string for delete failure
  const [deletingAccount, setdeletingAccount] = useState('')
  const deleteScan = async (accountId: string) => {
    try {
      setdeletingAccount(accountId)
      await API.graphql<GraphQLQuery<DeleteAccountInfoMutation>>({
        query: deleteAccountInfo,
        variables: { input: {
          accountId: accountId
        }}
      })
      setdeletingAccount('')
      refetch()
    } catch (error: any) {
      // show alert box
    }
  }

  return (
    <Container>
      <NavBar />
      <Header as='h1'>Profile</Header>
      <Header as='h2'>User Info</Header>
      <List>
        <List.Item><List.Header>Email</List.Header>{email}</List.Item>
        <List.Item><List.Header>User Name</List.Header><UserName/></List.Item>
      </List>
      {isLoading ? <Loader active inline /> :
        <div>
          <List horizontal>
            <List.Item>

          <Header as='h2'>Accounts</Header>
            </List.Item>
            <List.Item>
              <List.Content>
              <Button.Group>
                <Button><Link to={"/accounts/addNew"}>Add New Account</Link></Button>
                <Button icon='refresh' onClick={() => refetch()}/>
              </Button.Group>
              </List.Content>
              </List.Item>
              </List>
          <List>
            {accounts?.map((account) => (
              <List.Item key={account?.accountId}>
                <List.Header>{account?.accountName}</List.Header>
                <List.Content floated="right">
                  <Button icon={'trash'} size="mini" loading={deletingAccount === account?.accountId}
                    onClick={() => deleteScan(account?.accountId!)}/>
                </List.Content>
                <List.Content>{account?.accountId}</List.Content>
                <List.Content>{account?.monitorRoleArn}</List.Content>
                <List.Content><RenderAccountQuota accountId={account?.accountId!}/></List.Content>
              </List.Item>
            ))}
          </List>
        </div>}
    </Container>
  )
}